module.exports = __webpack_public_path__ + "img/406.d062dd65.png";